import { KubernetesQuotaListDto } from '@api-open';
import { FormatUnits } from '@utils/format-units';

import { ProjectResources } from './project-resources.interface';

export interface ProjectResourcesQuota {
  quotas?: ProjectResources;
  usages?: ProjectResources;
}

export function getProjectResourcesQuotas(measures: KubernetesQuotaListDto): ProjectResourcesQuota {
  let quotas: ProjectResources | undefined;

  if (
    measures.sumOfCpu &&
    measures.sumOfCpuRequests &&
    measures.sumOfRamInGb &&
    measures.sumOfRamRequestsInGb &&
    measures.podsCapacity
  ) {
    quotas = {
      pods: measures.podsCapacity,
      cpuRequests: measures.sumOfCpuRequests * 1_000,
      cpuLimits: measures.sumOfCpu * 1_000,
      ramRequests: FormatUnits(measures.sumOfRamRequestsInGb).from('GB').to('MB').value(),
      ramLimits: FormatUnits(measures.sumOfRamInGb).from('GB').to('MB').value(),
    };
  }

  return {
    quotas,
    usages: {
      pods: measures.podsTotalCount,
      cpuRequests: measures.sumOfCpuRequestsUsage * 1_000,
      cpuLimits: measures.sumOfCpuUsage * 1_000,
      ramRequests: FormatUnits(measures.sumOfRamRequestsUsage).from('Bytes').to('MB').value(),
      ramLimits: FormatUnits(measures.sumOfRamUsage).from('Bytes').to('MB').value(),
    },
  };
}
